module.exports = __webpack_public_path__ + "static/values-win-together-3cfa0de22388facdd0e91176b8252c53.svg";